import Vue from 'vue';
Vue.prototype.$formatTime = function(time) {
    time = String(time).padStart(2, '0');
    return time;
};
